if (!customElements.get('product-info')) {
  customElements.define(
    'product-info',
    class ProductInfo extends HTMLElement {
      constructor() {
        super();
        var _this = this;
        this.input = this.querySelector('.quantity__input');
        this.currentVariant = this.querySelector('.product-variant-id');
        this.variantSelects = this.querySelector('variant-radios');
        this.submitButton = this.querySelector('[type="submit"]');
        this.subscribeBox = this.querySelector('[data-product-subscription-box]');
        this.stickyATCSelect = document.querySelector('[data-sub-select]');
        this.stickyATCBtn = document.querySelector('[data-sticky-atc]');
        this.customDietBox = this.querySelector('[data-product-custom-diet-box]');

        if(this.subscribeBox != null){
          this.subscribeBox.querySelectorAll('input').forEach((input) =>{
            input.addEventListener('change', function(){
              _this.onSubOptionChange(input);
            })
          })
        }
        if(this.stickyATCSelect != null && this.subscribeBox != null){
          this.stickyATCSelect.addEventListener('change',function(){
            let val = _this.stickyATCSelect.value;
            let input = _this.subscribeBox.querySelector('input[id="'+val+'"]');
            // console.log('valuee',val);
            input.checked = true;
            input.dispatchEvent(new Event('change', { bubbles: true }));
          })
        }
        if(this.stickyATCBtn != null){
          this.stickyATCBtn.addEventListener('click',function(){
            this.querySelector('.product-form__buttons__text').classList.add('hidden');
            this.querySelector('.loading-overlay__spinner').classList.remove('hidden');
            _this.submitButton.click();
          })
        }

        if(this.customDietBox != null && this.customDietBox.querySelector('input') != null){
          this.customDietBox.querySelector('input').addEventListener('change',function(){
            if(_this.submitButton.querySelector('[data-atc-price]') != null){
              if(this.checked){
                _this.submitButton.querySelector('[data-atc-price]').innerHTML = _this.querySelector('#radio-onetime').checked ? _this.querySelector('input[data-variant-selects]:checked').dataset.atcBtnPrice :  _this.querySelector('input[data-variant-selects]:checked').dataset.subAtcPrice;
                _this.stickyATCBtn.querySelector('[data-atc-price]').innerHTML = _this.querySelector('#radio-onetime').checked ? _this.querySelector('input[data-variant-selects]:checked').dataset.atcBtnPrice :  _this.querySelector('input[data-variant-selects]:checked').dataset.subAtcPrice;
              } else{
                _this.submitButton.querySelector('[data-atc-price]').innerHTML = _this.querySelector('#radio-onetime').checked ? _this.querySelector('input[data-variant-selects]:checked').dataset.price :  _this.querySelector('input[data-variant-selects]:checked').dataset.subPrice;
                _this.stickyATCBtn.querySelector('[data-atc-price]').innerHTML = _this.querySelector('#radio-onetime').checked ? _this.querySelector('input[data-variant-selects]:checked').dataset.price :  _this.querySelector('input[data-variant-selects]:checked').dataset.subPrice;
              }
            }

          })
        }
        
      }

      cartUpdateUnsubscriber = undefined;
      variantChangeUnsubscriber = undefined;

      connectedCallback() {
        if (!this.input) return;
        this.quantityForm = this.querySelector('.product-form__quantity');
        if (!this.quantityForm) return;
        this.setQuantityBoundries();
        if (!this.dataset.originalSection) {
          this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, this.fetchQuantityRules.bind(this));
        }
        this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
          const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;
          if (event.data.sectionId !== sectionId) return;
          this.updateQuantityRules(event.data.sectionId, event.data.html);
          this.setQuantityBoundries();
        });
      }

      disconnectedCallback() {
        if (this.cartUpdateUnsubscriber) {
          this.cartUpdateUnsubscriber();
        }
        if (this.variantChangeUnsubscriber) {
          this.variantChangeUnsubscriber();
        }
      }

      onSubOptionChange(input){
        let atcBtnPrice = input.closest('product-info').querySelector('[data-atc-price]');
        let stickyatcBtnPrice = document.querySelector('[data-sticky-atc] [data-atc-price]');
        let customDietBox = input.closest('product-info').querySelector('[data-product-custom-diet-box]');

        if(atcBtnPrice != null) atcBtnPrice.innerHTML = input.dataset.atcPrc;
        if(stickyatcBtnPrice != null) stickyatcBtnPrice.innerHTML = input.dataset.atcPrc;

        if(input.getAttribute('id') == 'radio-onetime'){
          input.closest('product-info').querySelectorAll('.quantity-pack-card').forEach(function(mainele){
            if(mainele.querySelectorAll('[data-cur-comp-price]') != null) mainele.querySelectorAll('[data-cur-comp-price]').forEach((ele) => {ele.innerHTML = mainele.querySelector('input[type="radio"]').dataset.comPrice;})
            if(mainele.querySelectorAll('[data-cur-price]') != null) mainele.querySelectorAll('[data-cur-price]').forEach((ele) => {ele.innerHTML = mainele.querySelector('input[type="radio"]').dataset.price;})
            if(mainele.querySelectorAll('[data-per-pcs-subprice]') != null) mainele.querySelectorAll('[data-per-pcs-subprice]').forEach((ele) => {ele.innerHTML = mainele.querySelector('input[type="radio"]').dataset.perPcsPrice;})
            if(mainele.querySelectorAll('[data-dis-badge]') != null) mainele.querySelectorAll('[data-dis-badge]').forEach((ele) => {ele.innerHTML = mainele.querySelector('input[type="radio"]').dataset.compDiscount;})
          });
        }else{
          input.closest('product-info').querySelectorAll('.quantity-pack-card').forEach(function(mainele){
            if(mainele.querySelectorAll('[data-cur-comp-price]') != null) mainele.querySelectorAll('[data-cur-comp-price]').forEach((ele) => {ele.innerHTML = mainele.querySelector('input[type="radio"]').dataset.comPrice;})
            if(mainele.querySelectorAll('[data-cur-price]') != null) mainele.querySelectorAll('[data-cur-price]').forEach((ele) => {ele.innerHTML = mainele.querySelector('input[type="radio"]').dataset.subPrice;})
            if(mainele.querySelectorAll('[data-per-pcs-subprice]') != null) mainele.querySelectorAll('[data-per-pcs-subprice]').forEach((ele) => {ele.innerHTML = mainele.querySelector('input[type="radio"]').dataset.perPcsPricesub;})
            if(mainele.querySelectorAll('[data-dis-badge]') != null) mainele.querySelectorAll('[data-dis-badge]').forEach((ele) => {ele.innerHTML = mainele.querySelector('input[type="radio"]').dataset.subDiscount;})
          });
        }

        if(this.stickyATCSelect != null) this.stickyATCSelect.value = input.getAttribute('id')
    
        if(customDietBox != null){
          let inp = customDietBox.querySelector('input');
          let discountSVG = customDietBox.querySelector('svg');
          // console.log('idd',input.getAttribute('id'));
          if(input.getAttribute('id') == 'radio-onetime'){
            customDietBox.querySelector('.radio-label-price span.radio-label-price-regular').classList.remove('hidden');
            customDietBox.querySelector('input').value = inp.dataset.normalVariantId;
            customDietBox.querySelector('.radio-label-price span.radio-label-price-regular').innerHTML = inp.dataset.normalVariantCompPrice;
            customDietBox.querySelector('.radio-label-price span.radio-label-price-discount').innerHTML = inp.dataset.normalVariantPrice;
            customDietBox.querySelector('input').checked = false;
            var event = new Event('change');
            customDietBox.querySelector('input').dispatchEvent(event);
          } else{
            customDietBox.querySelector('input').checked = true; // check if subscription is selected
            var event = new Event('change');
            customDietBox.querySelector('input').dispatchEvent(event);
            customDietBox.querySelector('input').value = customDietBox.querySelector('input').dataset.subVariantId;
            if(inp.dataset.normalVariantCompPrice == '$0' ) customDietBox.querySelector('.radio-label-price span.radio-label-price-regular').classList.add('hidden');
            customDietBox.querySelector('.radio-label-price span.radio-label-price-discount').innerHTML = inp.dataset.subVariantPrice == '$0' ? 'FREE' : inp.dataset.subVariantPrice ;
          }
          // customDietBox.querySelectorAll('.radio-label-price span').forEach((ele) => ele.classList.toggle('hidden'));
          discountSVG.style.display = customDietBox.querySelector('.radio-label-price span.radio-label-price-discount').innerHTML == 'FREE' ? 'block' : 'none';
        } 
       
      }

      setQuantityBoundries() {
        const data = {
          cartQuantity: this.input.dataset.cartQuantity ? parseInt(this.input.dataset.cartQuantity) : 0,
          min: this.input.dataset.min ? parseInt(this.input.dataset.min) : 1,
          max: this.input.dataset.max ? parseInt(this.input.dataset.max) : null,
          step: this.input.step ? parseInt(this.input.step) : 1,
        };

        let min = data.min;
        const max = data.max === null ? data.max : data.max - data.cartQuantity;
        if (max !== null) min = Math.min(min, max);
        if (data.cartQuantity >= data.min) min = Math.min(min, data.step);

        this.input.min = min;
        this.input.max = max;
        this.input.value = min;
        publish(PUB_SUB_EVENTS.quantityUpdate, undefined);
      }

      fetchQuantityRules() {
        if (!this.currentVariant || !this.currentVariant.value) return;
        if(this.querySelector('.quantity__rules-cart .loading-overlay') != null) this.querySelector('.quantity__rules-cart .loading-overlay').classList.remove('hidden');
        fetch(`${this.dataset.url}?variant=${this.currentVariant.value}&section_id=${this.dataset.section}`)
          .then((response) => {
            return response.text();
          })
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            this.updateQuantityRules(this.dataset.section, html);
            this.setQuantityBoundries();
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            if(this.querySelector('.quantity__rules-cart .loading-overlay') != null) this.querySelector('.quantity__rules-cart .loading-overlay').classList.add('hidden');
          });
      }

      updateQuantityRules(sectionId, html) {
        const quantityFormUpdated = html.getElementById(`Quantity-Form-${sectionId}`);
        const selectors = ['.quantity__input', '.quantity__rules', '.quantity__label'];
        for (let selector of selectors) {
          const current = this.quantityForm.querySelector(selector);
          const updated = quantityFormUpdated.querySelector(selector);
          if (!current || !updated) continue;
          if (selector === '.quantity__input') {
            const attributes = ['data-cart-quantity', 'data-min', 'data-max', 'step'];
            for (let attribute of attributes) {
              const valueUpdated = updated.getAttribute(attribute);
              if (valueUpdated !== null) current.setAttribute(attribute, valueUpdated);
            }
          } else {
            current.innerHTML = updated.innerHTML;
          }
        }
      }
    }
  );
}
